﻿import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const ownerAPI = new API({
  url: `${process.env.REACT_APP_DOMAIN}/api/ownershipchange`,
  scopes: ExtHubRequest,
});

ownerAPI.createEntities([
  { name: 'getOwnershipChangeInformation' },
  { name: 'generateTransactionID' },
  { name: 'getOwnershipTransactionInformation' },
  { name: 'updateAuditHistoryStatus' },
  { name: 'requestOwnershipChangeLetter' },
]);

const GetOwnershipChangeInformation = (body) =>
  ownerAPI.endpoints.getOwnershipChangeInformation.post(body);
const GenerateTransactionID = (body) => ownerAPI.endpoints.generateTransactionID.post(body);
const GetOwnershipTransactionInformation = (body) =>
  ownerAPI.endpoints.getOwnershipTransactionInformation.post(body);
const UpdateAuditHistoryStatus = (body) => ownerAPI.endpoints.updateAuditHistoryStatus.post(body);
const RequestOwnershipChangeLetter = (body) =>
  ownerAPI.endpoints.requestOwnershipChangeLetter.post(body);

export {
  GetOwnershipChangeInformation,
  GenerateTransactionID,
  GetOwnershipTransactionInformation,
  UpdateAuditHistoryStatus,
  RequestOwnershipChangeLetter,
};
